import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import * as S from './styled/FormHeader.styled';

/**
 * @author @buunsal
 */

const FormHeader = ({ backUrl, icon, logo, lightTitle, boldTitle, className }) => {
	const navigate = useNavigate();

	return (
		<S.HeaderRowContainer className={`formHeader ${className ?? ''}`}>
			{icon && (
				<Button
					variant="borderless"
					style={{ marginLeft: '-1rem' }}
					icon={icon}
					iconSize="medium"
					iconButton
					onClick={() => navigate(backUrl ?? -1)}
				/>
			)}
			{logo && <Image url={logo} height={'var(--logoSize)'} width={'var(--logoSize)'} />}
			<S.HeaderColumnContent>
				{lightTitle && <Typography>{lightTitle}</Typography>}
				{boldTitle && (
					<Typography variant="p1" fontWeight="500">
						{boldTitle}
					</Typography>
				)}
			</S.HeaderColumnContent>
		</S.HeaderRowContainer>
	);
};

export default FormHeader;
